import { Form } from '../components/Form/Form';
import ScreenPhone from '../components/screenPhone';
import '../styles/Home.css'
import PricePlan from '../components/PricePlan';
import Footer from '../includes/Footer';
import Header from '../includes/Header';

function App() {
    return (
        <div>
           <Header />
            <div className="relative isolate overflow-hidden py-10 sm:py-10">
                <main className='max-w-screen-xl mx-auto lg:mt-5'>
                    <div className='w-full flex flex-col lg:flex-row gap-20'>
                        <div className="w-[90%] lg:w-2/3 mx-auto flex gap-4 flex-col justify-center">
                            <h2 className="text-4xl font-bold tracking-tight text-white sm:text-6xl color-base ">Jogo da memória dos casais</h2>
                            <p className="mt-6 text-lg leading-8 text-gray-300 font-default text-left">
                                Crie um jogo de memória personalizado com as melhores lembranças do seu relacionamento! Faça o upload de suas fotos favoritas, e receba um site exclusivo + QR Code para compartilhar e jogar junto com o seu amor. Reviva momentos especiais enquanto se diverte! 💖
                            </p>
                            <Form />
                        </div>
                        <div className='w-full lg:w-1/3 flex flex-col gap-3 items-center justify-center'>
                            <ScreenPhone img="img/jogo-dos-casais-memoria.png" />
                        </div>
                    </div>
                </main>
                <div className="relative isolate overflow-hidden py-10 sm:py-10">
                <section className='max-w-screen-xl mx-auto lg:mt-5'>
                    <h2 className="text-4xl md:text-left font-bold tracking-tight text-white sm:text-6xl color-base">Como funciona ?</h2>
                        <div className='grid md:grid-cols-3 gap-4 mt-8'>
                            <div>
                                <ScreenPhone img="img/step1.png" />
                                <div>
                                </div>
                            </div>
                            <div>
                                <ScreenPhone img="img/step2.png" />
                            </div>
                            <div>
                                <ScreenPhone img="img/step3.png" />
                            </div>
                        </div>
                        <div className='grid grid-cols-1 mt-10'>
                            <div className='text-center'>
                                <p className='font-default font-500 text-xl mb-4'>Adicione o nome do casal, as fotos e a descrição delas, elas serão usadas no jogo.</p>
                                <p className='font-default font-600 text-2xl mb-4 color-base'>Adicione a foto daquele momento mara!</p>
                                <p className='font-default font-700 text-3xl mb-4'>Capriche na descrição delas, elas serão usadas no jogo.</p>
                                <p className='font-default font-800 text-4xl mb-4 color-base'>Ao acertar as imagens, a foto com a mensagem será mostrada. Surpreenda na mensagem!</p>
                            </div>
                        </div>
                </section>
                <section className='price-plan'>
                    <PricePlan />
                </section>
                <Footer />
                
            </div>
            </div>
        </div>
    );
}
export default App
